var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"image-modal","hide-footer":"","size":"xl","title":_vm.login},on:{"hide":_vm.onModalHide}},[_c('b-img',{attrs:{"center":"","fluid":"","src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }